// extracted by css-extract-rspack-plugin
module.exports =  {"container":"JobCreationFormView__container___Y7EEj","loading":"JobCreationFormView__loading___Qs823"};